// extracted by mini-css-extract-plugin
export default {"customCheckbox":"customCheckbox_customCheckbox__H10AY","checkmark":"customCheckbox_checkmark__-XUDf"};